import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  title?: string;
};

type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[Surf ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="surf-error-boundary" role="alert">
          <h2>{this.props.title ?? "Qualcosa è andato storto"}</h2>
          <p className="muted">{this.state.error.message}</p>
          <button type="button" className="primary-btn" onClick={() => this.setState({ error: null })}>
            Riprova
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
